export default __webpack_public_path__ + "static/media/cif-ao.7d838311.svg";